import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useStore } from '../../app/stores/store'
import ProfileContent from './ProfileContent'
import ProfileHeader from './ProfileHeader'
import LoadingComponent from '../../app/layout/LoadingComponents'
import NotFound from '../errors/NotFound'

export default observer(function ProfilePage () {
  const { username } = useParams<{ username: string }>()
  const { profileStore } = useStore()
  const { profile, loadingProfile, loadProfile, canEdit } = profileStore

  useEffect(() => {
    loadProfile(username)
  }, [username, loadProfile])

  if (loadingProfile) return <LoadingComponent content="Loading profile..." />
  if (!profile) return <NotFound />

  return (
    <div className="w-full h-full bg-gray-100">
      <ProfileHeader profile={profile} canEdit={canEdit} />
      <ProfileContent profile={profile} canEdit={canEdit} />
    </div>
  )
})
